<nav class="d-flex align-items-center flex-wrap" [class.mt-3]="offsetTop" aria-label="Page navigation" *ngIf="visible">
  <div>
    <ngb-pagination class="mb-0" aria-label="Default pagination"
                    [collectionSize]="collectionSize"
                    [pageSize]="pageLimit"
                    [maxSize]="maxSize"
                    [rotate]="true"
                    [(page)]="currentPage"
                    (pageChange)="setPage($event)">
      <ng-template ngbPaginationPrevious>
        <div aria-label="caret-left" class="page-left-caret">
        </div>
      </ng-template>
      <ng-template ngbPaginationNext>
        <div aria-label="caret-left" class="page-right-caret">
        </div>
      </ng-template>
    </ngb-pagination>
  </div>

  <div class="ml-auto">
    <ng-select class="pagination-control__limit-input"
               placeholder="№"
               [items]="pageLimitItems"
               [searchable]=false
               [appendTo]="'body'"
               [hideSelected]=true
               [clearable]="false"
               [(ngModel)]="pageLimit"
               (change)="setPageLimit(pageLimit)">
      <ng-template ng-label-tmp let-item="item">
        <span class="text-muted mr-1">Items per page:</span>
        {{ pageLimit }}
      </ng-template>
    </ng-select>
  </div>

  <div class="ml-3" *ngIf="maxSize < pagesNum">
    <form class="d-flex align-items-center"
          [formGroup]="paginationForm"
          (ngSubmit)="setCurrentPage(paginationForm)">
      <label for="setPage" class="text-muted mb-0">
        Go to the page:
      </label>

      <div class="d-flex">
        <input type="number"
               id="setPage"
               class="form-control pagination-control__page-input"
               placeholder="№"
               name="setPage"
               formControlName="setPage" validate popper>
        <div class="input-group-append">
          <button class="btn btn-square btn-secondary" [disabled]="paginationForm.invalid || paginationForm.disabled">
            <icon-check></icon-check>
          </button>
        </div>
      </div>
    </form>
  </div>
</nav>
